import moment from "moment";
import { useEffect, useState } from "react";
import DeleteModal from "../component/deleteModal";
import MainLayout from "../layout/main";
import { populateRentals } from "../service/cache";
import { getRentals, softDeleteRental } from "../service/callAPI";
import Schema from "../type/schema";
import { DataTable } from "../component/DataTable2";
import { DateSelector } from "../component/DateSelector";
import { ReloadComponent } from "../component/ReloadComponent";
import { DeleteComponent } from "../component/DeleteComponent";

export default function RentalListPage() {
	const [startDate, setStartDate] = useState(
		moment().subtract(1, "months").format("YYYY-MM-DD")
	);
	const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
	const [rentals, setRentals] = useState<Schema.Rental[]>([]);
	const [refreshTrigger, setRefreshTrigger] = useState(false);
	useEffect(() => {
		loadState();

		async function loadState() {
			const response = await getRentals({
				page: 1,
				limit: -1,
				startDate: {
					startDate: +moment(startDate).format("X"),
					endDate: +moment(endDate).format("X")
				}
			});
			const populatedRentals = await populateRentals(response.rentals);

			setRentals(populatedRentals);
		}
	}, [startDate, endDate, refreshTrigger]);

	const [selectedRows, setSelectedRows] = useState<any[]>([]);

	return (
		<MainLayout
			pageTitle="Quản Lý Đơn Thuê"
			title="Quản Lý Đơn Thuê"
			subTitle="Thêm, xóa, sửa bài viết. Nhấn vào đây để xem Hướng dẫn sử dụng"
		>
			<DateSelector {...{ startDate, setStartDate, endDate, setEndDate }}>
				<DataTable
					selectableRows
					onSelectedRowsChange={(state) => {
						setSelectedRows(state.selectedRows);
					}}
					title={<hr />}
					pagination
					filterEnabled
					customHeaderComponents={[
						DeleteComponent({
							selectedRows,
							setRefreshTrigger,
							deleteById: softDeleteRental
						}),
						ReloadComponent({ setRefreshTrigger })
					]}
					columns={[
						{
							name: "Ngày tạo",
							selector: (row) => row.formattedCreatedAt,
							format: (row) => (
								<a href={`/rental/${row.id}`}>{row.formattedCreatedAt}</a>
							),
							sortable: true,
							compact: true
						},
						{
							name: "Ngày thuê",
							selector: (row) => row.formattedStartDate,
							sortable: true,
							compact: true
						},
						{
							name: "Ngày hẹn trả",
							selector: (row) => row.formattedDueDate,
							sortable: true,
							compact: true
						},
						{
							name: "Ngày thực trả",
							selector: (row) => row.formattedReturnDate,
							sortable: true,
							compact: true
						},
						{
							name: "Tên khách hàng",
							selector: (row) => row.customerId,
							format: (row) => {
								if (row.customer) {
									return (
										<a href={`/customer/${row.customer.id}`}>
											{row.customer.name} | {row.customer.phone}
										</a>
									);
								}

								return "Not found";
							},
							sortable: true,
							compact: true,
							wrap: true
						},
						{
							name: "Trạng thái",
							selector: (row) => row.status,
							format: (row) => {
								if (row.status === "Đang thuê") {
									return <span style={{ color: "orange" }}>Đang thuê</span>;
								}
								return <span style={{ color: "green" }}>{row.status}</span>;
							},
							sortable: true,
							compact: true
						},
						{
							name: "Tổng phí",
							selector: (row) => row.totalFee,
							sortable: true,
							compact: true
						},
						{
							name: "Ghi chú",
							selector: (row) => row.note,
							sortable: true,
							compact: true,
							wrap: true
						}
					]}
					data={rentals}
				/>
			</DateSelector>

			<DeleteModal />
		</MainLayout>
	);
}
